import toastMessage from '@/components/Toast';
import { getThunkError } from '@/store/utility/thunkErrorUtils';
import apiInstance from '@api/index';
import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  HairyChartData,
  HairyChartDataPayload,
  HairyChartSelectionsPayload,
  HairyChartSelectionsResponse,
} from './types';

// Fetch the selectable IR indexes / FX pairs available for the chosen date range
export const fetchHairyChartSelections = createAsyncThunk<
  HairyChartSelectionsResponse,
  HairyChartSelectionsPayload,
  { rejectValue: string }
>(
  'hairyChartAnalysis/fetchSelections',
  async (payload, { rejectWithValue }) => {
    try {
      const response =
        await apiInstance.marketData.getHairyChartSelections(payload);
      return response.data.data as HairyChartSelectionsResponse;
    } catch (error: any) {
      const message = getThunkError(error);
      toastMessage.error(message || 'Failed to fetch hairy chart selections');
      return rejectWithValue(
        message || 'Failed to fetch hairy chart selections',
      );
    }
  },
);

// Fetch the chart series (actual, current forward, historic forwards) for native rendering
export const fetchHairyChartData = createAsyncThunk<
  HairyChartData,
  HairyChartDataPayload,
  { rejectValue: string }
>('hairyChartAnalysis/fetchData', async (payload, { rejectWithValue }) => {
  try {
    const response = await apiInstance.marketData.getHairyChartData(payload);
    return response.data.data as HairyChartData;
  } catch (error: any) {
    const message = getThunkError(error);
    toastMessage.error(message || 'Failed to fetch hairy chart data');
    return rejectWithValue(message || 'Failed to fetch hairy chart data');
  }
});
